import { z } from "zod";
import type { ProviderId} from "../provider-id";
import { providerIdZodSchema } from "../provider-id";

type ProviderSetLeaveMyStuffOutsideEnabledCommand = {
    _type: "PROVIDER_SET_LEAVE_MY_STUFF_OUTSIDE_ENABLED_COMMAND";
    providerId: ProviderId;
    enabled: boolean;
};

const providerSetLeaveMyStuffOutsideEnabledCommandZodSchema: z.ZodSchema<ProviderSetLeaveMyStuffOutsideEnabledCommand> =
    z.object({
        _type: z.literal("PROVIDER_SET_LEAVE_MY_STUFF_OUTSIDE_ENABLED_COMMAND"),
        providerId: providerIdZodSchema,
        enabled: z.boolean(),
    });

export { providerSetLeaveMyStuffOutsideEnabledCommandZodSchema };
export type { ProviderSetLeaveMyStuffOutsideEnabledCommand };
